import { useAuthContext } from 'components/app/components/auth/auth';
import { When } from 'packages/when/when';
import React, { ReactNode } from 'react';

interface BuyProcessFormUserTipProps {
  children: ReactNode | ReactNode[];
}

export const BuyProcessFormUserTip = ({
  children,
}: BuyProcessFormUserTipProps) => {
  const auth = useAuthContext();

  return <When condition={!auth.isAuthenticated}>{children}</When>;
};
